import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roles: [],
  status: "idle",
  error: null,
};

export const rolesByCountrySlice = createSlice({
  name: "rolesByCountry",
  initialState,
  reducers: {
    rolesRequested: (state) => {
      state.status = "loading";
    },
    rolesRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    rolesRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.roles = action.payload;
    },
  },
});

export const {
  rolesRequested,
  rolesRequestFailed,
  rolesRequestSucceeded,
} = rolesByCountrySlice.actions;

export default rolesByCountrySlice.reducer;
